import { Col, Layout, Row, Spin } from "antd";
import PostGrid from "@components/grid/PostGrid";
import { AttrProps } from "@customTypes/index";
import { WeeklyTopTenList } from 'src/blocks/weekly-top-ten-list';

interface CustomCollectionProps {
    className?: string;
    attrs: AttrProps;
}

const CustomCollection = ({ className, attrs }: CustomCollectionProps) => {
    const isLoading = false;
    return (
        <Layout className={`covr-custom-collection-section mar-bot-30 ${className}`}>
            {attrs?.title
                && <Row className="data-header">
                    <Col>
                        <h2>{attrs.title}</h2>
                    </Col>
                </Row>}

            <Row justify={`center`} className="data-body">
                <Col span={24}>
                    <Spin size="large" spinning={isLoading}>
                        {attrs.layout === 'WeeklyTopTenList'
                            ? <WeeklyTopTenList attrs={{
                                startCountFrom: attrs?.startCountFrom,
                                countSelect: attrs?.countSelect,
                                cta: attrs.cta,
                                allOpen: attrs.allOpen,
                                items: attrs?.items || []
                            }} />
                            : <PostGrid
                                data={attrs?.items}
                                showFields={['title', 'link', 'description']}
                                cta={attrs.cta}
                                perRow={attrs.perRow}
                            />
                        }
                    </Spin>
                </Col>
            </Row>

            {attrs.link?.url
                && <Row className="data-footer" justify="end">
                    <Col>
                        <a target={attrs.link.target} className="view-all" href={attrs.link.url}>
                            {attrs.link.title}
                        </a>
                    </Col>
                </Row>}
        </Layout >
    );
};

export default CustomCollection;

